import { AdminDownloadFileTypeEnum } from '@app/app.enum';
import environment from '@app/environments/environment';
import axios, { CancelToken } from 'axios';
import { Injectable } from 'injection-js';

@Injectable()
export class AdminManifestService {
	private baseUrl = environment.apiGateway.apiUrl;
	private adminManifestApiUrl = '';

	constructor() {
		this.adminManifestApiUrl = this.baseUrl + 'AdminManifest/downloadFile/';
	}

	/**
	 *  Get manifest file and carrier file
	 */
	public async getManifestCarrierFile(
		manifestId: string,
		fileType: AdminDownloadFileTypeEnum,
		cancelToken?: CancelToken
	): Promise<string> {
		try {
			const res = await axios.get<string>(this.adminManifestApiUrl, {
				cancelToken,
				params: {
					manifestId,
					fileType,
				},
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}
}



// WEBPACK FOOTER //
// ./src/services/admin-manifest.service.ts